import ScopedCssBaseLine from '@material-ui/core/ScopedCssBaseline'
import { ThemeProvider } from '@material-ui/core/styles'
import React, { FC } from 'react'

import { useStyles } from './RootContainer.styles'
import { theme } from './theme'

interface RootContainerProps {
  hasBackground?: boolean
}

export const RootContainer: FC<RootContainerProps> = ({ children, hasBackground = true }) => {
  const classes = useStyles({ hasBackground })

  return (
    <React.StrictMode>
      <ThemeProvider theme={ theme }>
        <ScopedCssBaseLine className={ classes.root }>
          { children }
        </ScopedCssBaseLine>
      </ThemeProvider>
    </React.StrictMode>
  )
}
